module.exports = __webpack_public_path__ + "img/home-banner.91cbe767.jpg";